import { render, staticRenderFns } from "./ExamDefinitionTable.vue?vue&type=template&id=6b1dd492"
import script from "./ExamDefinitionTable.vue?vue&type=script&lang=js"
export * from "./ExamDefinitionTable.vue?vue&type=script&lang=js"
import style0 from "./ExamDefinitionTable.vue?vue&type=style&index=0&id=6b1dd492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports